// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// rangeSlider
require('ion-rangeslider/js/ion.rangeSlider');

// Toastr
window.Toastr = require('toastr');
